<mat-list>
  <mat-list-item>
    <a [routerLink]="['integrations']" matTooltip="Integrations" matTooltipPosition="right">
      <mat-icon>chat</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item>
    <a [routerLink]="['webhooks']" matTooltip="Webhooks" matTooltipPosition="right">
      <mat-icon>settings</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item>
    <a [routerLink]="['retention']" matTooltip="Retention" matTooltipPosition="right">
      <mat-icon>schedule</mat-icon>
    </a>
  </mat-list-item>
</mat-list>
